import {defineAsyncComponent} from 'vue';

const popupQuickSearchBudgetGroupItem = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetGroupItemQuickSearchPopup.vue'),
);

const popupQuickSearchBudgetChapterGrade = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetChapterGradeQuickSearchPopup.vue'),
);

const popupBudgetSubKindItem = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetSubKindItemQuickSearchPopup.vue'),
);
const popupBudgetKindItem = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetKindItemQuickSearchPopup.vue'),
);
const popupBudgetSubItem = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetSubItemQuickSearchPopup.vue'),
);

const popupBudgetItemDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetItemDetailQuickSearchPopup.vue'),
);

const popupBudgetChapter = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetChapterQuickSearchPopup.vue'),
);

const popupBudgetSource = defineAsyncComponent(() =>
  import('@/views/budgetPlan/quickSearchPopup/BudgetSourceQuickSearchPopup.vue'),
)

export function registerQuickSearch(app) {
  app.component('BudgetGroupItemQuickSearchPopup', popupQuickSearchBudgetGroupItem);
  app.component('BudgetChapterGradeQuickSearchPopup', popupQuickSearchBudgetChapterGrade);
  app.component('BudgetSubKindItemQuickSearchPopup', popupBudgetSubKindItem);
  app.component('BudgetKindItemQuickSearchPopup', popupBudgetKindItem);
  app.component('BudgetSubItemQuickSearchPopup', popupBudgetSubItem);
  app.component('BudgetItemDetailQuickSearchPopup', popupBudgetItemDetail);
  app.component('BudgetChapterQuickSearchPopup', popupBudgetChapter);
  app.component('BudgetSourceQuickSearchPopup', popupBudgetSource);
}
